<!-- Show latest listings  -->
<app-listings-view [centered]="false" [infiniteScrollPercentage]="100" [listings]="listings" [periodInDays]="periodInDays"
                   [showMyListingMarker]="true" [thereIsMore]="false" [totalCount]="0"></app-listings-view>
<app-loading-spinner *ngIf="showLoadingSpinner" [centered]="true" [float]="false"></app-loading-spinner>
